import React from 'react';
import OtpInput from 'react-otp-input';
import styles from './styles.module.css';
import PropTypes from 'prop-types';
import { InputHelperText } from '../FormInputs';
import cn from 'classnames';
import { Box } from '@material-ui/core';

const InputOtp = ({ value, handleChange, error, helperText, name }) => {
    return (
        <Box className={styles.inputWrapper}>
            <OtpInput
                value={value}
                onChange={handleChange}
                numInputs={6}
                containerStyle={styles.container}
                inputStyle={cn(styles.otpInput, error && styles.error)}
                renderInput={(props) => <input {...props} name={name} />}
                shouldAutoFocus
                inputType="tel"
            />
            {error && <InputHelperText helperText={helperText} />}
        </Box>
    );
};

InputOtp.propTypes = {
    value: PropTypes.string,
    handleChange: PropTypes.func,
    error: PropTypes.bool,
    helperText: PropTypes.string,
    name: PropTypes.string,
};

export default InputOtp;
